import AutocompleteLocationHandler from "./AutocompleteLocationHandler";
import Autocomplete from "./Autocomplete";
export default class CarPoolsAssessmentsCreate {

    constructor(selector) {
        this.$plugin = $(selector)
        let $plugin = this.$plugin
        if ($plugin.length === 0) {
            return false
        }

        new Autocomplete('[data-vinDataInput]', '[data-vinDataSelect]');
        window.AutocompleteLocationHandler = new AutocompleteLocationHandler(selector);

        this.$form = this.$plugin.find('form')
        this.dropArea = document.querySelector('[data-tncp-carpoolsassessmentscreate="drop"]')
        this.selectedFilesWrapper = document.querySelector('[data-tncp-carpoolsassessmentscreate="selectedFilesWrapper"]')
        this.selectedFiles = document.querySelector('[data-tncp-carpoolsassessmentscreate="selectedFiles"]')
        this.maxUploadSizeReached = document.querySelector('[data-tncp-carpoolsassessmentscreate="maxUploadSizeReached"]')
        this.cancelButton = document.querySelector('[data-tncp-carpoolsassessmentscreate="cancelButton"]')
        this.submitButton = document.querySelector('#submitButton')
        this.validateFormButton = document.querySelector('#validateFormButton')
        this.hasUpload = this.dropArea !== null
        this.maxUploadSize = 20971520 // 20 megabytes
        this.oldVin = ''

        this.assessmentType = document.querySelector('[data-assessmentType]')
        this.vinDataInput = document.querySelector('[data-vinDataInput]')
        this.vinDataSelect = document.querySelector('[data-vinDataSelect]')
        this.licensePlateSelect = document.querySelector('[data-licensePlateDataSelect]')
        this.licensePlateInput = document.querySelector('[data-licensePlateData]')
        this.licensePlateDataInfo = document.querySelector('[data-licensePlateDataInfo]')
        this.vinDataInfo = document.querySelector('[data-vinDataInfo]')

        this.translationlabels = document.querySelector('[data-translationlabels]')

        this.translationData = JSON.parse(this.translationlabels.innerHTML);

        this.filesArray = []
        this.existingDocuments = this._loadExistingDocuments()
        this.init()
    }

    init() {
        let vm = this
        // Make the showUserValidationPopup method accessible globally
        window.showUserConfirmationPopup = vm.showUserValidationPopup.bind(vm);

        vm.licensePlateSelect.style.display = 'none';
        vm.vinDataSelect.style.display = 'none';

        if(vm.vinDataInput.value) {
            vm.vinDataInput.value = vm.vinDataInput.value.toUpperCase()
            let vinDataSelectElement = $(vm.vinDataSelect).find('option[data-vin="' + vm.vinDataInput.value + '"]')
            if (vinDataSelectElement.length > 0) {
                vm.vinDataSelect.selectedIndex = vinDataSelectElement.index()
            }
        }

        if (vm.hasUpload) {
            vm.showSelectedFiles()

            // event listener: prevent default behaviour
            ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
                vm.dropArea.addEventListener(eventName, vm.preventDefaults, false)
            })

            // event listener: drag over dropzone
            ;['dragenter', 'dragover'].forEach(eventName => {
                vm.dropArea.addEventListener(eventName, () => {
                    vm.highlight()
                }, false)
            })

            // event listener: dragleave & drop over dropzone
            ;['dragleave', 'drop'].forEach(eventName => {
                vm.dropArea.addEventListener(eventName, () => {
                    vm.unhighlight()
                }, false)
            })

            // event listener: drop files
            vm.dropArea.addEventListener('drop', (event) => {
                vm.handleDrop(event)
            }, false)
        }

        this.vinDataInput.addEventListener('input', function (event) {
            vm.onchangeVinDataInput()
        }, false)

        this.vinDataInput.addEventListener('blur', function (event) {
            setTimeout(function () {
                vm.onchangeVinDataInput()
                vm.checkVinIsInExistingVehicles()
            }, 100)
        }, false)

        document.addEventListener("click", function (event) {
            vm.onclickDocument()
        }, false)

        this.licensePlateInput.addEventListener('input', function (event) {
            vm.onchangeLicensePlateInput()
        }, false)

        this.cancelButton.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent the form from submitting immediately
            $.magnificPopup.close();
        });


        this.validateFormButton.addEventListener('click', function (event) {
            event.preventDefault();
            if (vm.validateForm() === true) {
                vm.showUserValidationPopup()
            }
        });

        this.submitButton.addEventListener('click', function (event) {
            let xhrUrl = vm.$form.attr('action')
            let completeUploadFinished = false
            let promises = []
            let formData = new FormData();

            if (vm.hasUpload) {
                vm.showSelectedFiles()
            }

            vm.showLoadingPopup()

            vm.$form.serializeArray().forEach((element) => {
                formData.append(element.name, element.value);
            });

            if (vm.hasUpload && vm.filesArray.length > 0) {
                vm.filesArray.forEach((file, index) => {
                    formData.append("tx_tuevnordcustomerportal_api[file][" + index + "]", vm.filesArray[index]);
                });
            }

            let promise = new Promise((resolve, reject) => {

                //xhr
                window.xhrRequest({
                    url: xhrUrl,
                    method: 'POST',
                    data: formData,
                    timeout: 120000
                }).then((response) => {
                    console.log("No files to upload ...");
                    console.log(response.data.result)

                    resolve(response.data.result)
                }).catch((e) => {
                    reject(e);
                })
            })
            // push promise to promises array
            promises.push(promise)


            // if all promises are resolved
            Promise.all(promises).then((results) => {
                console.log('Results after promise: ', results)
                completeUploadFinished = true
                vm.hidePopups()

                // behaviour if not all uploads succeded / if all uploads succeded
                if (vm.checkCompleteResponseResult(results) === false) {
                    let reason = results[0] ? results[0].reason : ''
                    if (reason === 'wrong_state') {
                        console.log('Upload failed. Wrong assessment state.')
                        vm.showConfirmationPopup('error-wrong-state')
                    } else if (reason === 'server_error') {
                        console.log('Upload failed. Server error.')
                        vm.showConfirmationPopup('error-server')
                    } else {
                        console.log('Upload done. Partial success.')
                        vm.showConfirmationPopup('partialsuccess')
                    }
                } else {
                    console.log('Upload done. Form uploaded.')
                    if (vm.hasUpload) {
                        vm.flushFilesArray()
                    }
                    vm.showConfirmationPopup('success')
                }
                vm.enableSubmitButton()
            }).catch((e) => {
                vm.hidePopups()
                vm.enableSubmitButton()
                vm.showConfirmationPopup('error-server')
                console.log(e)
            });

            // prevent the defaults on submit
            vm.preventDefaults(event)
        })
    }

    checkVinIsInExistingVehicles() {
        if (this.assessmentType.value === 'ExistingVehicle') {
            let vin = this.vinDataInput.value
            if (vin !== '' && vin.length > 16) {
                let licensePlateSelectElement = $(this.licensePlateSelect).find('option[data-vin="' + vin.toUpperCase() + '"]')
                if (licensePlateSelectElement.length > 0) {
                    this.vinDataInfo.innerHTML = ''
                } else {
                    this.vinDataInfo.innerHTML = this.translationData['errorNotExistingVehicle']
                }
            }
        }else {
            this.vinDataInfo.innerHTML = ''
        }
    }

    onclickDocument() {
        if (this.oldVin !== this.vinDataInput.value) {
            this.oldVin = this.vinDataInput.value
            this.onchangeVinDataInput()
        }
    }

    onchangeLicensePlateInput() {
        this.licensePlateInput.value = this.licensePlateInput.value.toUpperCase()
        this.selectLicensePlateByManualInput(this.licensePlateInput.value)
        this.oldVin = this.vinDataInput.value
    }

    onchangeVinDataInput() {
        this.vinDataInput.value = this.vinDataInput.value.toUpperCase()
        let licensePlate = this.vinDataSelect.options[this.vinDataSelect.selectedIndex].getAttribute('data-licensePlate')
        this.selectLicensePlateByVinAndLicensePlate(this.vinDataInput.value, licensePlate)
        this.oldVin = this.vinDataInput.value
    }

    selectLicensePlateByManualInput(licensePlate) {
        let licensePlateSelectElement = $(this.licensePlateSelect).find('option[value="' + licensePlate.toUpperCase() + '"]')
        if (licensePlateSelectElement.length > 0) {
            this.licensePlateSelect.selectedIndex = licensePlateSelectElement.index()

            this.setLicensePlateInfoText(licensePlateSelectElement)
        } else {
            this.licensePlateDataInfo.innerHTML = ''
        }
    }

    selectLicensePlateByVinAndLicensePlate(vin, licensePlate) {
        let licensePlateSelectElement = $(this.licensePlateSelect).find('option[data-vin="' + vin.toUpperCase() + '"][value="' + licensePlate.toUpperCase() + '"]')
        if (licensePlateSelectElement.length > 0) {
            this.licensePlateSelect.selectedIndex = licensePlateSelectElement.index()
            this.licensePlateInput.value = this.licensePlateSelect.options[this.licensePlateSelect.selectedIndex].value

            this.setLicensePlateInfoText(licensePlateSelectElement)
            this.setAssessmentTypeToExistingVehicle()
        } else {
            this.licensePlateDataInfo.innerHTML = ''
        }
    }

    setAssessmentTypeToExistingVehicle() {
        this.assessmentType.value = 'ExistingVehicle'
    }

    setLicensePlateInfoText(licensePlateSelectElement) {
        let infos = {
            customerNumber: [this.translationData['customerNumber'] + ' ', licensePlateSelectElement.attr('data-customerNumber')],
            producer: [this.translationData['producer'] + ' ', licensePlateSelectElement.attr('data-producer')],
            typeText: [this.translationData['typeText'] + ' ', licensePlateSelectElement.attr('data-typeText')],
            constructionYear: [this.translationData['constructionYear'] + ' ', licensePlateSelectElement.attr('data-constructionYear')]
        }

        let infoText = ''
        Object.entries(infos).forEach(([key, value]) => {
            if (value[1] !== '') {
                if (infoText === '') {
                    infoText = value.join('')
                } else {
                    infoText += ', ' + value.join('')
                }
            }
        });

        this.licensePlateDataInfo.innerHTML = infoText
    }

    validateForm() {
        const form = document.getElementById('assessmentForm');
        return Array.from(form.querySelectorAll('[required]')).every(el => el.reportValidity());
    }

    handleDrop(event) {
        let dt = event.dataTransfer;
        let files = dt.files;
        this.handleFiles(files);
    }

    handleFiles(files) {
        let vm = this;
        ([...files]).forEach(file => {
            vm.addFile(file)
        });
    }

    addFile(file) {
        if (this.existsInFilesArray(file) === false) {
            this.filesArray.push(file)
        }
        console.log(`File added with filename "${file.name}". Now containing ${this.filesArray.length} file(s)`)
        this.showSelectedFiles()
        this.toggleSubmitActivation()
    }

    removeFile(index, reloadSelectedFiles = true) {
        this.filesArray.splice(index, 1);
        console.log(`Remove file with index ${index} from files. Remaining files count: ${this.filesArray.length}`)
        console.log('Remaining files:', this.filesArray)

        if (reloadSelectedFiles) {
            this.showSelectedFiles()
        }
        this.toggleSubmitActivation()

        if (this.filesArray.length === 0 && this.existingDocuments.length === 0) {
            let $selectedFilesWrapper = $(this.selectedFilesWrapper)
            $selectedFilesWrapper.hide();
        }
    }

    removeFileByName(fileName, reloadSelectedFiles = true) {
        let vm = this
        console.log('removeFileByName triggered ...')
        this.filesArray.forEach((result, key) => {
            if (fileName === result.name) {
                vm.removeFile(key, reloadSelectedFiles)
            }
        })
    }

    flushFilesArray() {
        this.filesArray = []
        this.showSelectedFiles()
    }

    toggleSubmitActivation() {
        if ((this.hasFiles() || this.existingDocuments.length > 0) && this.checkMaxUploadSizeReached() === false) {
            this.enableSubmitButton()
        } else {
            this.disableSubmitButton()
        }
    }

    hasFiles() {
        return this.filesArray.length > 0;
    }

    getFiles() {
        return this.filesArray();
    }

    checkMaxUploadSizeReached() {
        return this.getFilesize() >= this.maxUploadSize;
    }

    checkCompleteResponseResult(results) {
        let status = true
        results.forEach((result) => {
            if (result.uploadStatus === false && status !== false) {
                status = false
            }
        });
        return status
    }

    getFilesize() {
        let fileSize = 0
        if (this.filesArray.length > 0) {
            this.filesArray.forEach((file) => {
                fileSize = fileSize + file.size
            });
        }
        return fileSize
    }

    showSelectedFiles() {
        let vm = this
        let $selectedFilesWrapper = $(this.selectedFilesWrapper)
        let $selectedFiles = $(this.selectedFiles)
        $selectedFilesWrapper.hide();
        $selectedFiles.html('')

        if (this.existingDocuments.length > 0) {
            $selectedFilesWrapper.show();
            this.existingDocuments.forEach((doc) => {
                let remarks = doc.remarks ? `<br><i>${doc.remarks}</i>` : ''
                $selectedFiles.append(`<div class="c-dragndrop__file-wrap"><div class="c-dragndrop__file-name"><b>${doc.name}</b>${remarks}</div></div>`)
            })
        }

        if (this.filesArray.length > 0) {
            $selectedFilesWrapper.show();
            this.filesArray.forEach((file, index) => {
                let fileSize = vm.formatBytes(file.size, 1)
                $selectedFiles.append(`<div class="c-dragndrop__file-wrap" data-tncp-carpoolsassessmentscreate-selectedindex="${index}" data-tncp-carpoolsassessmentscreate-selectedfile="${file.name}"><div class="c-dragndrop__file-name">${file.name} (${fileSize}) <span data-tncp-carpoolsassessmentscreate-fileexists="${index}" style="display: none; margin-left: 0;"><br><i><b>Datei existiert bereits</b></i></span></div><div class="c-dragndrop__file-delete" onclick="window.CarPoolsAssessmentsCreate.removeFromSelectedFiles('${file.name}')"><span data-icon="ui_close"></span></div></div>`)
            });
        }

        if (vm.checkMaxUploadSizeReached()) {
            vm.showMaxUploadSizeReached()
        } else {
            vm.hideMaxUploadSizeReached()
        }
    }

    removeFromSelectedFiles(fileName) {
        console.log(`removeFromSelectedFiles triggered for file "${fileName}" ...`)
        this.removeFileByName(fileName, false)
        $(`[data-tncp-carpoolsassessmentscreate-selectedfile="${fileName}"]`).hide()
    }

    highlight() {
        this.dropArea.classList.add('is-active')
    }

    unhighlight() {
        this.dropArea.classList.remove('is-active')
    }

    showMaxUploadSizeReached() {
        if (this.maxUploadSizeReached) {
            this.maxUploadSizeReached.style.display = 'block'
        }
    }

    hideMaxUploadSizeReached() {
        if (this.maxUploadSizeReached) {
            this.maxUploadSizeReached.style.display = 'none'
        }
    }

    enableSubmitButton() {
        this.submitButton.disabled = false
    }

    disableSubmitButton() {
        this.submitButton.disabled = true
    }

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    _loadExistingDocuments() {
        const el = document.querySelector('[data-tncp-carpoolsassessmentscreate-existingdocuments]')
        if (!el) {
            return []
        }
        try {
            return JSON.parse(el.innerHTML)
        } catch (e) {
            return []
        }
    }

    existsInFilesArray(fileName) {
        let status = false
        if (this.filesArray.length > 0) {
            this.filesArray.forEach((existingFile) => {
                if (fileName.name === existingFile.name && status !== true) {
                    status = true
                }
            });
        }
        if (!status && this.existingDocuments.length > 0) {
            this.existingDocuments.forEach((doc) => {
                if (fileName.name === doc.name && status !== true) {
                    status = true
                }
            })
        }
        return status
    }

    showLoadingPopup() {
        $.magnificPopup.close()
        $.magnificPopup.open({
            items: {
                src: '#popup_loadingAssessmentsUpload',
            },
            type: 'inline',
            closeOnBgClick: false,
            enableEscapeKey: false,
            showCloseBtn: false,
            overflowY: 'hidden'
        });
    }

    showConfirmationPopup(type) {
        $.magnificPopup.close();
        this.$form.hide();
        const el = document.querySelector(`[data-carpoolsassessmentscreate="${type}"]`);
        if (el) {
            el.classList.remove('mfp-hide');
        }
    }

    showUserValidationPopup() {
        let identifierElement
        identifierElement = '#popup_uservalidation'

        const formData = ['customerNumberData', 'vinDataInput', 'licensePlateData', 'ownerNameData', 'ownerEmailData', 'ownerPhoneData'];
        let map = new Map();


        formData.forEach(field => {
            let element = document.querySelector(`[data-${field}]`);
            map.set(field, element.value);
        })


        // Transfer input data from form to popup
        formData.forEach(field => {
            document.querySelector(`[data-popup-${field}]`).setAttribute('value', map.get(field));
        });

        $.magnificPopup.open({
            items: {
                src: identifierElement,
            },
            type: 'inline',
        });

    }

    hidePopups() {
        $.magnificPopup.close();
    }

    preventDefaults(e) {
        e.preventDefault()
        e.stopPropagation()
    }
}
